/* jQuery Password Strength Plugin (pstrength) - A jQuery plugin to provide accessibility functions
 * Author: Tane Piper (digitalspaghetti@gmail.com)
 * Website: http://digitalspaghetti.me.uk
 * Licensed under the MIT License: http://www.opensource.org/licenses/mit-license.php
 * This code uses a modified version of Steve Moitozo's algorithm (http://www.geekwisdom.com/dyn/passwdmeter)
 *
 * === Changelog ===
 * Version 1.2x (16/07/2015)
 * spar customization
 * 
 * Version 1.2 (03/09/2007)
 * Added more options for colors and common words
 * Added common words checked to see if words like 'password' or 'qwerty' are being entered
 * Added minimum characters required for password
 * Re-worked scoring system to give better results
 *
 * Version 1.1 (20/08/2007)
 * Changed code to be more jQuery-like
 *
 * Version 1.0 (20/07/2007)
 * Initial version.
 */
(function($){
	$.extend($.fn, {
		pstrength : function(options) {
			var options = $.extend({
				scores: 	[10,15,30,40]
			},options);
			return this.each(function(){
				var $curr = $(this);
				$(this).keyup(function(){
					$.fn.runPassword($(this).val(), $curr, options);
				});
			});
		},
		runPassword : function (password, $inputSelected, options){
			// Check password
			nPerc = $.fn.checkPassword(password, options);
			//get labels element
			var $pstrengthContainer = $inputSelected.next(".pstrengthContainer");
			var $weakLabel = $pstrengthContainer.find(".pstrengthWeak");
			var $mediumLabel = $pstrengthContainer.find(".pstrengthMedium");
			var $strongLabel = $pstrengthContainer.find(".pstrengthStrong");
			var weakOpenClass=false,mediumOpenClass=false,strongOpenClass=false;
			
			if($inputSelected.val()!==""){
				if (nPerc < 0){/*too short - not handled in spar*/}
				else if(nPerc <= options.scores[0]){//Very Weak
					weakOpenClass = true;
				}
				else if (nPerc > options.scores[0] && nPerc <= options.scores[1]){ //Weak
					weakOpenClass = true;
				}
				else if (nPerc > options.scores[1] && nPerc <= options.scores[2]){ //Medium
					mediumOpenClass = true;
				}
				else if (nPerc > options.scores[2] && nPerc <= options.scores[3]){ //Strong	
					strongOpenClass = true;
				}
				else{//Very Strong
					strongOpenClass = true;
				}
			}
			
			//assign open classes
			$pstrengthContainer.toggleClass("open", weakOpenClass || mediumOpenClass || strongOpenClass);
			$weakLabel.toggleClass("open",weakOpenClass);
			$mediumLabel.toggleClass("open",mediumOpenClass);
			$strongLabel.toggleClass("open",strongOpenClass);
		},
		checkPassword : function(password, options)
		{
			var intScore = 0;
			// PASSWORD LENGTH
			if (password.length < options.minchar)                         // Password too short
			{
				intScore = (intScore - 100)
			}
			else if (password.length >= options.minchar && password.length <= (options.minchar + 2)) // Password Short
			{
				intScore = (intScore + 6)
			}
			else if (password.length >= (options.minchar + 3) && password.length <= (options.minchar + 4))// Password Medium
			{
				intScore = (intScore + 12)
			}
			else if (password.length >= (options.minchar + 5))                    // Password Large
			{
				intScore = (intScore + 18)
			}
			if (password.match(/[a-z]/))                              // [verified] at least one lower case letter
			{
				intScore = (intScore + 1)
			}
			if (password.match(/[A-Z]/))                              // [verified] at least one upper case letter
			{
				intScore = (intScore + 5)
			}
			// NUMBERS
			if (password.match(/\d+/))                                 // [verified] at least one number
			{
				intScore = (intScore + 5)
			}
			if (password.match(/(.*[0-9].*[0-9].*[0-9])/))             // [verified] at least three numbers
			{
				intScore = (intScore + 7)
			}
			// SPECIAL CHAR
			if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~]/))            // [verified] at least one special character
			{
				intScore = (intScore + 5)
			}
			// [verified] at least two special characters
			if (password.match(/(.*[!,@,#,$,%,^,&,*,?,_,~].*[!,@,#,$,%,^,&,*,?,_,~])/))
			{
				intScore = (intScore + 7)
			}
			// COMBOS
			if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/))        // [verified] both upper and lower case
			{
				intScore = (intScore + 2)
			}
			if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) // [verified] both letters and numbers
			{
				intScore = (intScore + 3)
			}
		 	// [verified] letters, numbers, and special characters
			if (password.match(/([a-zA-Z0-9].*[!,@,#,$,%,^,&,*,?,_,~])|([!,@,#,$,%,^,&,*,?,_,~].*[a-zA-Z0-9])/))
			{
				intScore = (intScore + 3)
			}
			return intScore;
		}
	});
})(jQuery);